import React, { useEffect, useState } from 'react';

// Hooks
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { fetchExportLogs } from '~/redux/actions/export-logs-actions';

// Utils
import { MESSAGES } from '~/utils/message';
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Component
import ExportLogsTable from './ExportTable';

// MUI Components
import { Box, Typography } from '@mui/material';

const Export = () => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [initialLoad, setInitialLoad] = useState(true);

  const dispatch = useDispatch();
  const rowsCount = useSelector((state) => state.exportLogsReducers.rowsCount) || 0;

  useEffect(() => {
    const payload = {
      page: pagination?.page || DEFAULT_PAGINATION.page,
      pageSize: pagination?.pageSize || DEFAULT_PAGINATION.pageSize,
    };
    let isActive = true;

    dispatch(fetchExportLogs(payload)).finally(() => {
      if (isActive) {
        setInitialLoad(false);
      }
    });

    return () => {
      isActive = false;
    };
  }, [pagination.page, pagination.pageSize, dispatch]);

  return (
    <>
      <Box className="importExportTabContent">
        {rowsCount > 0 && (
          <Box className="olcHeaderWrap importExportListHeader">
            <Box>
              <Typography className="pageTitle" variant="h4">
                {MESSAGES.ACCOUNT.EXPORT_LOGS.TITLE}
              </Typography>
            </Box>
          </Box>
        )}
        <ExportLogsTable
          pagination={pagination}
          updatePagination={setPagination}
          initialLoad={initialLoad}
        />
      </Box>
    </>
  );
};

export default Export;
